export enum SelectPriorityType{
    PRIMARY = "PRIMARY",
    SECONDARY = "SECONDARY"
}